import React from "react";
import { School, Group, TrendingUp } from "@material-ui/icons";
import "./HomeSections.css";

const STEPS = [
  {
    icon: School,
    title: "Register your school",
    text: "Create an account and set up your school profile with ease. Our onboarding process is designed to get you started quickly.",
  },
  {
    icon: Group,
    title: "Add teachers & students",
    text: "Manage classroom details and student information efficiently. Our intuitive interface makes data management simple.",
  },
  {
    icon: TrendingUp,
    title: "Track progress",
    text: "Monitor activities and communicate with parents effectively. Real-time insights help improve learning outcomes.",
  },
];

// Three connected steps: a numbered node on a line, with the step card below it.
const HowItWorks = () => (
  <section className="hs" aria-labelledby="how-it-works-title">
    <div className="hs__inner">
      <header className="hs__header">
        <p className="hs__eyebrow">Get started</p>
        <h2 className="hs__title" id="how-it-works-title">Ready in <span className="lh-blue">three simple</span> steps.</h2>
        <p className="hs__lead">
          Get started with MonteStory in three simple steps and transform your school
          management experience today.
        </p>
      </header>

      <ol className="hw__steps">
        {STEPS.map(({ icon: Icon, title, text }, index) => (
          <li className="hw__step" key={title}>
            <span className="hw__dot" aria-hidden>{index + 1}</span>
            <div className="hw__card">
              <span className="hw__icon" aria-hidden>
                <Icon />
              </span>
              <h3 className="hw__step-title">{title}</h3>
              <p className="hw__step-text">{text}</p>
            </div>
          </li>
        ))}
      </ol>
    </div>
  </section>
);

export default HowItWorks;
